// import React from 'react';
import { APIScope, LocationVarKey } from "@swivl-mono/types";
import { useState } from "react";
import { FaComputer } from "react-icons/fa6";
import { useNavigate } from "react-router-dom";

import { ShowIf } from "../../../Components/ShowIf/ShowIf";
import { useLocationVariables } from "../../../Hooks/useLocationVariables";
import AccountModel from "../../../Models/Account/AccountModel";
import { Member } from "../../../Models/Member/Member.Current";
import "./MainMenu.scss";

// import {AnalyticsEvent} from '../../../Helpers/Analytics/AnalyticsEvent'
// import { AppModel } from '../../../Models/App/App.Model';
// import UserModel from '../../../Models/User/UserModel';
// import BotModel from '../../../Models/Bots/Bot.Model';
// import { useSwivlNavigate } from '../../../Models/NavBar/useSwivlNavigate';
// import SubscriptionModel from '../../../Models/Subscription/Subscription.Model';

export function MainMenu() {
  const navigate = useNavigate();
  const [showMainMenu, setShowMenu] = useState(false); //AppModel.useState(s => s.showMainMenu)
  const { memberships } = AccountModel.useState((s) => s);
  const orgVars = useLocationVariables([LocationVarKey.Name, LocationVarKey.AvatarURL]);

  const toggleMainMenu = () => {
    setShowMenu(!showMainMenu);
  };
  // const permissions = UserModel.useState(s => s.permissions)
  // const bot = BotModel.useState(s => s.bot)

  // const navigate = useSwivlNavigate()
  const dashboardClicked = () => {
    // AnalyticsEvent("Main Menu", "Section", "Dashboard");
    toggleMainMenu();
    navigate("/");
  };

  const locationsClick = () => {
    // AnalyticsEvent("Main Menu", "Section", "Dashboard");
    toggleMainMenu();
    navigate("/properties");
  };
  const conversationsClicked = () => {
    // AnalyticsEvent("Main Menu", "Section", "Conversations");
    toggleMainMenu();
    navigate("/conversations");
  };
  //   const  trainingClicked = () => {
  //     AnalyticsEvent("Main Menu", "Section", "Interactions");
  //     toggleMainMenu()
  //     navigate("/interactions/results")
  //   }
  //   const myStorageClicked = () => {
  //     AnalyticsEvent("Main Menu", "Section", "My Storage");
  //     toggleMainMenu()
  //     navigate("/my-storage")
  //   }

  const reviewsClicked = () => {
    // AnalyticsEvent("Main Menu", "Section", "Reviews");
    toggleMainMenu();
    navigate("/reviews");
  };
  const settingsClicked = () => {
    // AnalyticsEvent("Main Menu", "Section", "Settings");
    toggleMainMenu();
    navigate("/settings/account");
  };
  const adminClicked = () => {
    // AnalyticsEvent("Main Menu", "Section", "Settings");
    toggleMainMenu();
    navigate("/admin");
  };

  //     let conversations, training, reviews, myStorage;
  //     let iconsCount = 2;

  //     if (permissions.conversations)  {
  //       iconsCount++;
  //       conversations = <div className="mainNavButton"  onClick={conversationsClicked}>
  //           <span className="icon"><img src='/img/main-nav/Conversations.png' alt="Conversations" width={60} height={45}/></span>
  //           <span className="title">Conversations</span>
  //         </div>;
  //     }
  //     if (permissions.training) {
  //       iconsCount++;
  //       training = <div className="mainNavButton"  onClick={trainingClicked}>
  //             <span className="icon"><img src='/img/main-nav/Training.png' alt="Training" width={64} height={65}/></span>
  //             <span className="title">Interactions</span>
  //           </div>;
  //         }

  //         if (bot.get("worksheetSettings")) {
  //           iconsCount++;
  //           myStorage =            <div className="mainNavButton"  onClick={myStorageClicked}>
  //           <span className="icon"><img src='/img/main-nav/MyStorage.png' alt="MyStorage" width={65} height={45}/></span>
  //           <span className="title">My Storage</span>
  //         </div>
  //               }
  //       if (permissions.reviews_manager && SubscriptionModel.showReviewManager()) {
  //         iconsCount++;
  //         reviews = <div className="mainNavButton"  onClick={reviewsClicked}>
  //             <span className="icon"><img src='/img/main-nav/Reviews.png' alt="Reviews" width={64} height={45}/></span>
  //             <span className="title">Reviews</span>
  //           </div>
  //       }

  //     // if (permissions.user_journeys) {
  //     //   iconsCount++;
  //     //   user_journeys = <div className="mainNavButton"  onClick={userJoureysClicked}>
  //     //               <span className="icon"><img src='/img/main-nav/UserJourneys.png' alt="Journeys" width={65} height={58}/></span>
  //     //               <span className="title">Workflows</span>
  //     //             </div>
  //     // }

  const numberOfIcons = 4;
  // const modalStyle = {width:((numberOfIcons * 210) + 10) + "px"};

  const contextWarning =
    import.meta.env.VITE_CONTEXT === "production" ? null : (
      <div className={"contextWarning"}>
        <FaComputer /> {import.meta.env.VITE_CONTEXT}
      </div>
    );
  // const contextWarning =  <div className="contextWarning">{import.meta.env.VITE_CONTEXT}</div>;

  return (
    <>
      <div className={showMainMenu ? "MainMenuShade isShowing" : "MainMenuShade"} onClick={toggleMainMenu} />

      <div
        className={showMainMenu ? "MainMenu isShowing" : "MainMenu"}
      // style={modalStyle}
      >
        {Member.isSuperAdmin && (
          <div className="AdminButton" onClick={adminClicked}>
            Admin Panel
          </div>
        )}
        <div className="mainNavButton" onClick={dashboardClicked}>
          <span className="icon">
            <img src="https://swivl-cdn.s3-us-west-1.amazonaws.com/website/main-menu/Dashboard.png" alt="Dashboard" width={60} height={45} />
          </span>
          <span className="title">Dashboard</span>
        </div>

        <ShowIf scope={APIScope.CONVERSATION_VIEW}>
          <div className="mainNavButton" onClick={conversationsClicked}>
            <span className="icon">
              <img
                src="https://swivl-cdn.s3-us-west-1.amazonaws.com/website/main-menu/Conversations.png"
                alt="Conversations"
                width={60}
                height={45}
              />
            </span>
            <span className="title">Conversations</span>
          </div>
        </ShowIf>

        <ShowIf scope={APIScope.REVIEWS_EDIT}>
          <div className="mainNavButton" onClick={reviewsClicked}>
            <span className="icon">
              <img src="https://swivl-cdn.s3-us-west-1.amazonaws.com/website/main-menu/Reviews.png" alt="Reviews" width={60} height={45} />
            </span>
            <span className="title">Reviews</span>
          </div>
        </ShowIf>

        <div className="mainNavButton" onClick={locationsClick}>
          <span className="icon">
            <img src="https://swivl-cdn.s3-us-west-1.amazonaws.com/website/main-menu/MyStorage.png" alt="Locations" width={60} height={45} />
          </span>
          <span className="title">Property Manager</span>
        </div>

        {/* {conversations}
        {reviews}
        {training}
        {myStorage} */}

        <div className="mainNavButton" onClick={settingsClicked}>
          <span className="icon">
            <img src="https://swivl-cdn.s3-us-west-1.amazonaws.com/website/main-menu/Settings.png" alt="Settings" width={55} height={55} />
          </span>
          <span className="title">Settings</span>
        </div>
      </div>
      <div className="mainNavToggleButton">
        <div className={showMainMenu ? "navButton openNav" : "navButton closeNav"} onClick={toggleMainMenu}>
          <div className="redStick"></div>
          <div className="yellowStick"></div>
        </div>
      </div>
      <div className={showMainMenu ? "menuPills openNav" : "menuPills"}>
        {orgVars && (
          <div className={"accountIndicator"}>
            {memberships && memberships.length > 1 && (
              <button
                className="accountSwitcher"
                onClick={() => {
                  if (showMainMenu) {
                    AccountModel.clearMember();
                  }
                }}
              >
                Switch Accounts
              </button>
            )}
            <div className="avatar">{orgVars[LocationVarKey.AvatarURL] && <img src={orgVars[LocationVarKey.AvatarURL]} alt="Avatar" />}</div>
            <div className="name">{orgVars[LocationVarKey.Name]}</div>
          </div>
        )}
        {contextWarning}
      </div>
    </>
  );
}
